export default "__VITE_PUBLIC_ASSET__b6b12752__"